/*
 * Countdown for the "selling out fast" block (blocks/pb-urgency.liquid).
 *
 * Counts down to midnight on Amsterdam time and starts again the next day. The wording comes
 * from the block (data-label, with %TIME% as the placeholder) so each shop language has its own.
 */
(() => {
  if (customElements.get('pb-urgency-timer')) return;

  /* Seconds left until midnight in Amsterdam. */
  function secondsLeft() {
    const parts = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Amsterdam',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23',
    })
      .formatToParts(new Date())
      .forEach((part) => (parts[part.type] = Number(part.value)));
    return 86400 - (parts.hour * 3600 + parts.minute * 60 + parts.second);
  }

  const pad = (value) => String(value).padStart(2, '0');

  class PbUrgencyTimer extends HTMLElement {
    connectedCallback() {
      this.label = this.dataset.label || '%TIME%';
      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    tick() {
      const left = secondsLeft() % 86400;
      const time = `${pad(Math.floor(left / 3600))}:${pad(Math.floor((left % 3600) / 60))}:${pad(left % 60)}`;
      this.textContent = this.label.replace('%TIME%', time);
    }
  }

  customElements.define('pb-urgency-timer', PbUrgencyTimer);
})();
